import { useMutation } from '@tanstack/react-query';
import { updateProject } from "@/api/project"; 
import { UpdateProjectData, ReturnProjectData } from "@/types/project"; 
import { PostParam } from "@/types/index"; 

export function useUpdateProject(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<ReturnProjectData, Error, UpdateProjectData>({
    mutationFn: updateProject,
    onSuccess,
    onError
  });
}
